import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { DataGridFlexSales, useDataGridFlexSales, useDataGridSync } from '../../DataGridFlexSales';

import {
  reportCausesFilterCauseSelector,
  reportCausesFilterCountrySelector,
  reportCausesFilterDateSelector,
  reportCausesFilterStoresSelector,
} from '../../../state';
import handlerFactory, { HeaderDataGridContext } from './handlerFactory';
import { MissingCauses, MissingClosingCauses } from '../../../types';

const Container = styled.div`
  height: 170px;
  min-height: 170px;
  overflow: hidden;

  @media (max-height: 820px), (max-width: 1366px) {
    height: 150px;
    min-height: 150px;
  }

  [data-tour='report-results'] {
    height: 100%;
    min-height: 0;
  }
`;

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<MissingClosingCauses, HeaderDataGridContext>();

  const { t } = useTranslation();

  const country = useSelector(reportCausesFilterCountrySelector);
  const store = useSelector(reportCausesFilterStoresSelector);
  const date = useSelector(reportCausesFilterDateSelector).accept as Date;
  const cause = useSelector(reportCausesFilterCauseSelector) as MissingCauses;
  const data = [{ country, store, date, cause }];

  const gridContext = useMemo(
    () => ({
      t,
    }),
    [t]
  );

  useDataGridSync({
    handler,
    data,
    context: gridContext,
  });

  return null;
};

const ErrorHeader = () => (
  <Container>
    <DataGridFlexSales handlerFactory={handlerFactory} hideToolbar>
      <DataGridConfig />
    </DataGridFlexSales>
  </Container>
);

export default ErrorHeader;
